'use client';

// Vendors
import { useTheme } from 'next-themes';
import { motion } from 'framer-motion';

// Global util
import { cn } from '@/lib/utils';

export const LoadingSpinner = () => {
  const { resolvedTheme } = useTheme();

  const borderColor =
    resolvedTheme === 'dark' ? 'border-gray-800' : 'border-white';
  const borderTopColor = 'border-t-transparent';

  return (
    <motion.div
      className={cn(
        'w-4 h-4 border-2 rounded-full animate-spin',
        borderColor,
        borderTopColor
      )}
      aria-label="Loading"
    />
  );
};
